module.exports = __webpack_public_path__ + "img/brand.167fbafe.png";